import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

/**
 * @prop {string} icon
 * @prop {string} type
 */

class CornerRibbon extends React.Component {
  render() {
    const { type } = this.props;
    const componentName = 'CornerRibbon';
    const ribbonClassNames = classNames(componentName, {
      [`${componentName}--success`]: type === 'success',
      [`${componentName}--warning`]: type === 'warning',
      [`${componentName}--danger`]: type === 'danger',
    });
    return (
      <div className={ribbonClassNames}>
        <Icon name={this.props.icon} className={`${componentName}-icon`} />
      </div>
    );
  }
}

export default CornerRibbon;
